export type SavePhase = 'idle' | 'validating' | 'saving' | 'locking' | 'completed';

export const SAVE_PHASE_LABELS: Record<Exclude<SavePhase, 'idle'>, string> = {
  validating: 'Validating…',
  saving: 'Saving configuration…',
  locking: 'Locking card…',
  completed: 'Completed.',
};

export type AppView = 'main' | 'success';
